module.exports = __webpack_public_path__ + "img/min_reintegration.c6951654.png";